import { Component } from "@angular/core";

import { StaticPageService } from "./static-page.service";
import {
    CreateMode,
    DisplayMode,
    IGridColumn,
    IGridSettings,
    ITableSettings,
    UpdateMode
} from "@features/grid";
import { UserHelperService } from "@main/users/user-helper.service";


@Component({
    templateUrl: "./static-pages.component.html"
})
export class StaticPagesComponent {
    tableSettings: ITableSettings = {
        columns: <IGridColumn[]>[
            { field: "alias", header: "Alias" },
            { field: "heading", header: "Heading" },
            { field: "contentPreview", header: "Content Preview", sortable: false },
            {
                field: "lastUpdated", header: "Last Updated", displayMode: DisplayMode.Date
            }
        ]
    };

    gridSettings: IGridSettings = {
        createMode: this.userHelperService.isSuperAdmin ? CreateMode.Redirect : CreateMode.Disabled,
        createLink: "/app/static/pages/edit/0",
        updateMode: this.userHelperService.isSuperAdmin || this.userHelperService.isMiProAdmin ? UpdateMode.Redirect : UpdateMode.Disabled,
        updateLink: "/app/static/pages/edit/:id",
        deletingEnabled: this.userHelperService.isSuperAdmin,
        exportEnabled: false
    };

    constructor(
        private staticPageService: StaticPageService,
        private userHelperService: UserHelperService
    ) {
        this.gridSettings.dataService = staticPageService;
    }
}